import { ScrollView, View } from "react-native";
import { useSettingsData } from "../../contexts/SettingsDataContext";
import { useActiveAgent } from "../../contexts/ActiveAgentContext";
import { useStripeClientSecret } from "../../contexts/StripeClientSecretContext";
import LoadingView from "../../components/common/loading-view";
import { StyledText } from "../../components/common/ui/styled-text";
import { ConnectDocuments } from "@stripe/react-connect-js";
import { GRAY_50 } from "../../constants/colors";

const Documents = () => {
  const { clientSecret } = useStripeClientSecret();
  const { activeAgent } = useActiveAgent();
  const { settings, isLoading } = useSettingsData();
  const connectedAccountId = settings?.stripeAccountId;

  if (!clientSecret || !connectedAccountId || !activeAgent) {
    return null;
  }

  if (isLoading) {
    return <LoadingView backgroundColor={GRAY_50} />;
  }

  return (
    <ScrollView className="flex-1 bg-gray-50">
      <View className="p-0 sm:p-6 space-y-4">
        <View className="bg-white sm:rounded-lg sm:border sm:border-gray-200 overflow-hidden">
          <View className="p-2 sm:p-4 border-b border-gray-200">
            <StyledText className="text-lg font-semibold text-gray-900">
              Tax Documents
            </StyledText>
            <StyledText className="text-sm text-gray-600">
              View your tax documents
            </StyledText>
          </View>
          <View className="bg-white p-2 sm:rounded-2xl sm:p-6 sm:shadow-sm">
            <ConnectDocuments />
          </View>
        </View>
      </View>
    </ScrollView>
  );
};

export default Documents;
